import { Form, message, Modal, Select } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { StockLocationDropdownRecord } from '../StockLocationDropdownRecord';
import { updatePurchaseOrderWithStockLocationId } from '../../thunks/purchase_orders_thunks';
import ModalFormFooter from '../common/ModalFormFooter';

export const VIA_SL_FORM_NAME = 'via-sl-form';

const ViaStockLocationModal: FC<any> = ({
	purchaseOrder = {},
	onCancel,
	onSuccess,

	stockLocations,
	fetchMultipleStockLocations,
	fetchStockLocations,
	updateViaStockLocationForPO,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const onSubmit = useCallback(
		(values) => {
			setSaving(true);
			updateViaStockLocationForPO({
				id: purchaseOrder.id,
				viaStockLocationId: values.viaStockLocationId,
			})
				.then(onSuccess)
				.catch(message.error)
				.finally(() => setSaving(false));
		},
		[onSuccess, purchaseOrder.id, updateViaStockLocationForPO]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={'Update Forwarding Stock Location'}
			closable
			onCancel={onCancel}
			forceRender
			footer={null}
		>
			<Form id={VIA_SL_FORM_NAME} layout="vertical" requiredMark={false} onFinish={onSubmit}>
				<Form.Item name="viaStockLocationId" label="Via Stock Location">
					<OWAsyncSelect
						stateSlice={stockLocations}
						allowClear
						targetCollectionName="viaStockLocationIndex"
						fetchMultiple={(ids, targetCollectionName) => {
							fetchMultipleStockLocations(ids, targetCollectionName);
						}}
						fetchData={(
							searchText,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						) => {
							fetchStockLocations(
								{ name: searchText },
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							);
						}}
						renderRecord={(record) => (
							<Select.Option key={`${record.id} - ${record.name}`} value={record.id}>
								<StockLocationDropdownRecord record={record} />
							</Select.Option>
						)}
					/>
				</Form.Item>
				<ModalFormFooter
					okText="Update"
					cancelText="Cancel"
					loading={saving}
					formId={VIA_SL_FORM_NAME}
					onCancelClick={onCancel}
				/>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	stockLocations: state.stock_locations,
});

const mapDispatchToProps = (dispatch) => ({
	fetchStockLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			stockLocationsRestCrudThunksForSupplier.read(
				{ ...params, allowEquipmentForwarding: true, noIsActiveFilter: false },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleStockLocations: (ids, targetCollectionName) =>
		dispatch(stockLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	updateViaStockLocationForPO: (data) => dispatch(updatePurchaseOrderWithStockLocationId(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViaStockLocationModal);
